// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import {Total_earnings} from '../../../comp/total_earnings';

export function Lifetime(){
    return <div>
      <Total_earnings/>
    </div>;
}
